import { UnifiedSearchApiResponse } from '../../types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';
export const postUnifiedSearch = async (
  word: string,
  limit: number,
  startToken?: string,
  practiceNextToken?: string,
  includeExternal?: boolean
): Promise<{
  data: UnifiedSearchApiResponse;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }
  if (!word || !limit) {
    throw new Error('Please provide both search word and limit');
  }

  // Always use query parameters to avoid gateways rejecting JSON body
  let loading = true;
  const queryParams = new URLSearchParams({
    customerId: customer,
    word: word,
    limit: limit.toString(),
  });

  if (startToken) {
    queryParams.append('startToken', startToken.toString());
  }
  if (practiceNextToken) {
    queryParams.append(
      'practiceNextToken',
      practiceNextToken.toString()
    );
  }
  if (includeExternal !== undefined) {
    queryParams.append('includeExternal', includeExternal.toString());
  }

  try {
    const responseData = await post(
      `resourceMatrix/unified_search/search?${queryParams.toString()}`,
      {}
    );
    const data = responseData as UnifiedSearchApiResponse;
    loading = false;
    return { data, loading };
  } catch (error) {
    loading = false;
    throw new Error(
      `Failed to perform unified search: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`
    );
  }
};
